/** Last changed query */
import type { QueryProps } from './query-props.js'
import manifest from '@tunasong/manifest'
import type { SearchRequest } from '@tunasong/schemas'

// eslint-disable-next-line no-underscore-dangle
const _source_excludes = ['embedding', 'acls', 'metadata']

const query = ({ query: parentId, size = 100 }: QueryProps): SearchRequest =>
  ({
    index: 'entities',
    size,
    from: 0,
    /** embeddings are large - don't return them by default */
    _source_excludes,
    body: {
      /** Return just 2 results per type */
      // collapse: {
      //   field: 'type.keyword',
      //   inner_hits: {
      //     name: 'type_group',
      //     size: 3,
      //     _source: {
      //       excludes: _source_excludes,
      //     },
      //   },
      // },
      sort: [{ updatedAt: { order: 'desc' } }, '_score'],
      query: {
        /** Match all documents */
        bool: {
          must: {
            match_all: {},
          },
          /** Filter out types we don't want in the recent list, as well as trash */

          must_not: {
            terms: { type: manifest.search.excludeFromRecent },
          },
          filter: {
            bool: {
              must: parentId ? { term: { 'parentChain.id.keyword': parentId } } : undefined,
              must_not: {
                term: { trash: true },
              },
            },
          },
        },
      },
    },
  }) satisfies SearchRequest

export default query
